import React from 'react'
import styled from "styled-components"
interface OrangeProps {
  title: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

const OrangeButton = styled.button`
  display: block;
  width: 85%;
  padding: 15px 0;
  font-family: inherit;
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  background-color: #F4C274;
  border: 0;
  border-radius: 4px;
  font-family:open sans;
  margin-top:23px;
  margin-bottom:20px;
  


  cursor: pointer;
  // transition: all 0.25s cubic-bezier(0.02, 0.01, 0.47, 1);
  padding-left:7px;
  padding-right:7px;

  &:active {
    // transform: translate(0, -5px);
    background-color: #FFF;
    color:#F4C274;
    border : 1px solid #F4C274;
  }
  &:hover {
    // transform: translate(0, -5px);
    background-color: #FFF;
    color:#F4C274;
    border : 1px solid #F4C274;
  }

`;
function histOrangeButton({ title, onClick }: OrangeProps) {
  return (
    <OrangeButton type="button" onClick={onClick}>
      {title}
    </OrangeButton>
  );
}

export default histOrangeButton